import { Component, Input, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-base",
  template: "<p>base works!</p>"
})
export class BaseComponent implements OnDestroy {

  constructor(protected translateService: TranslateService) { }

  @Input() componentTranslationRoot = "";

  isComponentDataLoaded = false;
  subscriptionsToRelease: Subscription[] = [];

  ngOnDestroy(): void {
    this.subscriptionsToRelease.forEach((s) => {
      s.unsubscribe();
    });
    this.subscriptionsToRelease = [];
  }

  translate(key: string, interpolateParams?: object, root = this.componentTranslationRoot): string {
    return this.translateService.instant(root + "." + key, interpolateParams);
  }
  ///method i here mostly for reusable components that might have their default translations for some keys
  //it should allow user not to duplicate values in translation files and same time give oprtunity to ovverride some of  default values for component
  translateWithFallback(key: string, fallbackRoot: string, interpolateParams?: object): string {
    const translationKey = this.componentTranslationRoot + "." + key;
    const translatedValue = this.translate(key, interpolateParams);
    if (translatedValue === translationKey) {
      return this.translate(key, interpolateParams, fallbackRoot);
    } else {
      return translatedValue;
    }
  }
}
